// Shared inline-SVG helper.
//
// The wizard draws its own icons rather than pulling in a library: one set, one
// stroke weight, no dependency, and nothing to go stale when a package updates.
// Everything is 24×24 with a 1.5px stroke — scale it down with width/height at
// the call site rather than changing the viewBox, so weights stay consistent.

/** Wrap raw path markup in the house 24×24 / 1.5px line-icon frame. */
export function svgIcon(paths: string): string {
  return `<svg class="kos-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
    aria-hidden="true">${paths}</svg>`;
}
